import React from 'react';

/**
 * Tarjeta base del rediseño de la app.
 *
 * @param {boolean} pad       aplica el padding estándar (22px)
 * @param {boolean} hoverable eleva la tarjeta al pasar el cursor
 */
export const Card = ({ pad = true, hoverable = false, className = '', children, ...rest }) => (
  <div
    className={[
      'a2-card',
      pad ? 'a2-card-pad' : '',
      hoverable ? 'a2-card-hoverable' : '',
      className,
    ].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </div>
);

/** Encabezado de tarjeta: título serif + subtítulo opcional + acción a la derecha. */
export const CardHeader = ({ title, subtitle, action, className = '' }) => (
  <div
    className={className}
    style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      flexWrap: 'wrap', gap: 10, marginBottom: subtitle ? 18 : 16,
    }}
  >
    <div style={{ minWidth: 0 }}>
      <h3 className="a2-card-title">{title}</h3>
      {subtitle ? <p className="a2-card-sub">{subtitle}</p> : null}
    </div>
    {action}
  </div>
);

export default Card;
